import React from "react";
import styles from "./RouteLoadingFallback.module.css";

const RouteLoadingFallback: React.FC = () => (
  <div className={styles.screen} role="status" aria-live="polite">
    <span className={styles.label}>Loading Future OS</span>
  </div>
);

export default RouteLoadingFallback;
